import { useState, useEffect } from 'react'
import { convertBase } from '../utils/baseConversion'
import { COMMON_BASES, ALL_BASES, DEFAULT_INPUT_BASE, DEFAULT_OUTPUT_BASE } from '../constants'

function BaseConverter() {
  const [inputBase, setInputBase] = useState(DEFAULT_INPUT_BASE)
  const [outputBase, setOutputBase] = useState(DEFAULT_OUTPUT_BASE)
  const [inputValue, setInputValue] = useState('')
  const [outputValue, setOutputValue] = useState('')

  // 当输入值、输入进制或输出进制改变时，执行转换
  useEffect(() => {
    if (inputValue === '') {
      setOutputValue('')
      return
    }

    try {
      const result = convertBase(inputValue, inputBase, outputBase)
      setOutputValue(result)
    } catch (error) {
      setOutputValue('')
    }
  }, [inputValue, inputBase, outputBase])

  const handleInputBaseChange = (base) => {
    setInputBase(Number(base))
    setInputValue('')
    setOutputValue('')
  }

  const handleOutputBaseChange = (base) => {
    setOutputBase(Number(base))
  }

  const handleInputChange = (e) => {
    setInputValue(e.target.value)
  }

  return (
    <div className="converter-section">
      <div className="section-title">在线进制转换</div>
      <div className="section-description">支持在2~36进制之间进行任意转换</div>
      
      {/* 输入进制选择 */}
      <div className="base-selector">
        <div className="radio-group">
          {COMMON_BASES.map((base) => (
            <label key={`input-${base}`} className="radio-label">
              <input
                type="radio"
                name="input_base"
                value={base}
                checked={inputBase === base}
                onChange={(e) => handleInputBaseChange(e.target.value)}
              />
              {base}进制
            </label>
          ))}
          <select
            value={inputBase}
            onChange={(e) => handleInputBaseChange(e.target.value)}
            className="base-select"
          >
            {ALL_BASES.map((base) => (
              <option key={`input-option-${base}`} value={base}>
                {base}进制
              </option>
            ))}
          </select>
        </div>
        <div className="input-group">
          <span className="input-label">转换数字</span>
          <input
            type="text"
            value={inputValue}
            onChange={handleInputChange}
            placeholder="在此输入待转换数字"
            className="converter-input"
          />
        </div>
      </div>

      {/* 输出进制选择 */}
      <div className="base-selector">
        <div className="radio-group">
          {COMMON_BASES.map((base) => (
            <label key={`output-${base}`} className="radio-label">
              <input
                type="radio"
                name="output_base"
                value={base}
                checked={outputBase === base}
                onChange={(e) => handleOutputBaseChange(e.target.value)}
              />
              {base}进制
            </label>
          ))}
          <select
            value={outputBase}
            onChange={(e) => handleOutputBaseChange(e.target.value)}
            className="base-select"
          >
            {ALL_BASES.map((base) => (
              <option key={`output-option-${base}`} value={base}>
                {base}进制
              </option>
            ))}
          </select>
        </div>
        <div className="input-group">
          <span className="input-label">转换结果</span>
          <input
            type="text"
            value={outputValue}
            readOnly
            placeholder="转换结果"
            className="converter-input"
          />
        </div>
      </div>
    </div>
  )
}

export default BaseConverter
